<template>
  <div>
    <h1>Populations</h1>
    <v-btn @click="generateNotices">
      <v-icon>refresh</v-icon>Generate notices
    </v-btn>
    <v-btn @click="generateArticles">
      <v-icon>refresh</v-icon>Generate articles
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="modifiedPopulations"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'population', params:{id:props.item.id}}" small>{{ props.item.id }}</v-btn>
          </td>
          <td>{{ props.item.name }}</td>
          <td>
            <router-link :to="{name:'county',params:{id:props.item.countyid}}">
              <span v-if="props.item.county">{{ props.item.county.name }}</span>
              <span v-if="!props.item.county">{{ props.item.countyid }}</span>
            </router-link>
          </td>
          <td>
            <EntityZ v-if="props.item.entity" :entity="props.item.entity" />
          </td>
          <td>
            <span v-if="props.item.articleCount">{{ props.item.articleCount }}</span>
            <v-progress-circular
              v-if="!articleCount"
              :width="2"
              :size="10"
              indeterminate
              color="info"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="generatingVisible" persistent width="300">
      <v-card color="error" dark>
        <v-card-text>
          <span>{{generatingContent}}</span>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Populations",
  metaInfo() {
    return {
      title: "Populations",
      titleTemplate: "%s - SEO - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    modifiedPopulations() {
      if (!this.populations) {
        return undefined;
      }
      const countiesMap = this.counties
        ? convertListOfObjectsToMap(this.counties, "id")
        : undefined;
      const entitiesMap = this.entities
        ? convertListOfObjectsToMap(this.entities, "id")
        : undefined;
      return this.populations.map(p => {
        const county = countiesMap ? countiesMap[p.countyid] : undefined;
        const entity =
          entitiesMap && entitiesMap[p.entityid]
            ? entitiesMap[p.entityid]
            : undefined;
        const articleCount = this.articleCount
          ? this.articleCount[p.entityid]
          : undefined;
        return { ...p, county, entity, articleCount };
      });
    }
  },
  data() {
    return {
      populations: null,
      articleCount: null,
      counties: null,
      entities: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "County",
          value: "county.name"
        },
        {
          text: "Branch",
          value: "entity.name"
        },
        {
          text: "Article count",
          value: "articleCount"
        }
      ],
      pagination: {
        rowsPerPage: -1
      },
      loading: false,
      generatingVisible: false,
      generatingContent: null
    };
  },
  methods: {
    fetchPopulations() {
      this.loading = true;
      nbmlaw.get(`/cors/admin/extras/populations`).then(response => {
        // console.log(response.data);
        this.populations = response.data;
        this.loading = false;
      });
    },
    fetchArticleCount() {
      this.articleCount = null;
      nbmlaw
        .get(`/cors/admin/extras/populations/articles/count`)
        .then(response => {
          // console.log(response.data)
          this.articleCount = response.data;
        });
    },
    fetchCounties() {
      nbmlaw.get(`/cors/admin/extras/counties`).then(response => {
        // console.log(response.data)
        this.counties = response.data;
      });
    },
    fetchBranches() {
      nbmlaw
        .get(`/cors/admin/directory/branches`)
        .then(response => {
          // console.log(response.data);
          this.entities = response.data;
        })
        .catch(() => {});
    },
    generateNotices() {
      this.generatingVisible = true;
      this.generatingContent = "Waiting for server to generate notices...";
      nbmlaw.post(`/cors/admin/extras/notices/generate/true`, null).then(() => {
        this.generatingVisible = false;
        this.fetchArticleCount();
        // console.log(response.data)
      });
    },
    generateArticles() {
      this.generatingVisible = true;
      this.generatingContent = "Waiting for server to generate articles...";
      nbmlaw
        .put(`/cors/admin/extras/populations/articles/generate`, null)
        .then(() => {
          this.generatingVisible = false;
          this.fetchArticleCount();
          // console.log(response.data)
        });
    }
  },
  created() {
    this.fetchBranches();
    this.fetchCounties();
    this.fetchArticleCount();
    this.fetchPopulations();
  }
};
</script>
